import { createRouter, createWebHistory } from 'vue-router';
import ProjetosPage from './views/ProjetosPage.vue';
import ContactoPage from './views/ContactoPage.vue';
import ServicosPage from './views/ServicosPage.vue';
import HomePage from './views/HomePage.vue';
import SobrePage from './views/SobrePage.vue';
import BlogPage from './views/BlogPage.vue';
import AutomacaoPage from './views/AutomacaoPage.vue';
import ClimatizacaoPage from './views/ClimatizacaoPage.vue';
import EletricidadePage from './views/EletricidadePage.vue';
import EletronicaPage from './views/EletronicaPage.vue';
import ElevadoresPage from './views/ElevadoresPage.vue';
import EsteirasPage from './views/EsteirasPage.vue';
import ManutencaoPage from './views/ManutencaoPage.vue';
import PortasPage from './views/PortasPage.vue';
import EletromecanicaPage from './views/EletromecanicaPage.vue';
import TelecomunicacaoPage from './views/TelecomunicacaoPage.vue';


const routes = [
  { path: '/', component: HomePage },
  { path: '/sobre', component: SobrePage },
  { path: '/servicos', component: ServicosPage },
  { path: '/projetos', component: ProjetosPage },
  { path: '/contacto', component: ContactoPage },
  { path: '/blog', component: BlogPage },
  { path: '//servicos/automacao', component: AutomacaoPage },
  { path: '/servicos/climatizacao', component: ClimatizacaoPage },
  { path: '/servicos/eletricidade', component: EletricidadePage },
  { path: '/servicos/eletronica', component: EletronicaPage },
  { path: '/servicos/elevadores', component: ElevadoresPage },
  { path: '/servicos/esteiras', component: EsteirasPage },
  { path: '/servicos/manutencao', component: ManutencaoPage },
  { path: '/servicos/portas', component: PortasPage },
  { path: '/servicos/eletromecanica', component: EletromecanicaPage },
  { path: '/servicos/telecomunicacao', component: TelecomunicacaoPage },


];

export default createRouter({
  history: createWebHistory(),
  routes,
});
